import React from 'react';
import { ThankYouViewDecorator } from 'site-modules/shared/components/lead-form/unified-lead-form/views/thank-you-view-decorator';

export function BaseThankYouViewUI() {
  return <div />;
}
export const BaseThankYouView = ThankYouViewDecorator(BaseThankYouViewUI);
